var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { css } from 'styled-components';
import { rem } from 'polished';
import { IconContainer } from './ButtonContent';
export var getFontSize = function getFontSize(_a) {
  var $size = _a.$size;

  if ($size === 'S' || $size === 'M') {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: 1rem;\n    "], ["\n      font-size: 1rem;\n    "])));
  }

  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1.125rem;\n  "], ["\n    font-size: 1.125rem;\n  "])));
};
export var getIconContainerSize = function getIconContainerSize(_a) {
  var $iconSize = _a.$iconSize;
  var size = rem(16);

  if ($iconSize === 'S') {
    size = rem(12);
  }

  if ($iconSize === 'M') {
    size = rem(16);
  }

  if ($iconSize === 'L') {
    size = rem(18);
  }

  if ($iconSize === 'XL') {
    size = rem(24);
  }

  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", " {\n      width: ", ";\n      height: ", ";\n      min-width: ", ";\n      min-height: ", ";\n    }\n  "], ["\n    ", " {\n      width: ", ";\n      height: ", ";\n      min-width: ", ";\n      min-height: ", ";\n    }\n  "])), IconContainer, size, size, size, size);
};
export var getHorizontalPadding = function getHorizontalPadding(_a) {
  var $size = _a.$size;

  if ($size === 'S') {
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "], ["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), rem(20), rem(20));
  }

  return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), rem(30), rem(30));
};
export var getHeightStyle = function getHeightStyle(_a) {
  var $size = _a.$size;

  if ($size === 'S') {
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      /* The small size is designed as 32px with 6px vertical padding to enable a 44px hit target*/\n      height: ", ";\n      position: relative;\n      margin: 6px 0;\n\n      &::before,\n      &::after {\n        content: '';\n        position: absolute;\n        left: 0;\n        height: 6px;\n        width: 100%;\n      }\n\n      &::before {\n        top: -6px;\n      }\n\n      &::after {\n        bottom: -6px;\n      }\n    "], ["\n      /* The small size is designed as 32px with 6px vertical padding to enable a 44px hit target*/\n      height: ", ";\n      position: relative;\n      margin: 6px 0;\n\n      &::before,\n      &::after {\n        content: '';\n        position: absolute;\n        left: 0;\n        height: 6px;\n        width: 100%;\n      }\n\n      &::before {\n        top: -6px;\n      }\n\n      &::after {\n        bottom: -6px;\n      }\n    "])), rem(32));
  }

  if ($size === 'M') {
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), rem(44));
  }

  if ($size === 'L') {
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), rem(48));
  }

  return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    height: ", ";\n  "], ["\n    height: ", ";\n  "])), rem(48));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;